import React, { useEffect } from 'react';

import { Container } from 'react-bootstrap';

import { Breadcrumb } from '../interfaces';
import { BreadcrumbToolbar, LogoToolbar, PageHeader } from '.';
import { scrollToTop } from '../utils';

interface PublicLayoutProps extends React.PropsWithChildren<unknown> {
  className?: string;
  fluid?: boolean;
  breadcrumbs?: Breadcrumb[];
  children: React.ReactNode;
  pageTitle?: string;
  customHeader?: boolean;
  // Optional content rendered inside the header, below the logo/links row:
  headerContent?: React.ReactNode;
}

export const PublicLayout = ({
  className,
  breadcrumbs,
  children,
  fluid = false,
  pageTitle,
  customHeader = false,
  headerContent
}: PublicLayoutProps) => {
  useEffect(scrollToTop, []);

  return (
    <>
      <LogoToolbar headerContent={headerContent} />
      {breadcrumbs && <BreadcrumbToolbar breadcrumbs={breadcrumbs} />}
      {pageTitle && <PageHeader pageTitle={pageTitle ?? ''} customHeader={customHeader} />}
      <Container fluid={fluid} className={((fluid ? `p-0 ${className}` : className) ?? '').trim()}>
        {children}
      </Container>
    </>
  );
};
